import React, { useState } from "react";

const StarRating = ({ rating, setRating }) => {
  const handleClick = (index) => {
    setRating(index + 1);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        cursor: "pointer",
        margin: "10px 0px",
      }}
    >
      {/* Render 5 stars */}
      {[...Array(5)].map((_, index) => (
        <Star
          key={index}
          filled={index < rating}
          onClick={() => handleClick(index)}
        />
      ))}
    </div>
  );
};

// Star Component to display each individual star
const Star = ({ filled, onClick }) => (
  <span
    onClick={onClick}
    style={{
      fontSize: "24px",
      marginRight: "5px",
      color: filled ? "#FDC040" : "grey",
    }}
  >
    ★
  </span>
);

export default StarRating;
